export default "__VITE_ASSET__CaVzqYOS__"